<template>
  <div>
    <earth-animation />
  </div>
</template>

<script>
import EarthAnimation from '@/components/on-board/EarthAnimation.vue'

export default {
  components: {
    EarthAnimation
  },
  mounted() {
    this.$jbUtils.toggle(false)
    this.$store.commit('layout/FULL_PAGE', true)
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>
